<footer class="container">
  <div class="row">
    <div class="col-md-4 offset-md-4 col-sm-12 my-5 text-center">
      <img class="img-fluid" src="../../../../../assets/brand.svg" alt="" id="footerLogo">
      <p class="text-white font-brand-secondary">Todos los derechos reservados © {{year}}</p>
    </div>
  </div>
</footer>